import React, { useState, useEffect, useRef, useCallback } from 'react';
import { View, Image, Platform, Linking, ScrollView, Text, Animated, ActivityIndicator } from 'react-native';
import { createDrawerNavigator, DrawerItemList, DrawerItem } from '@react-navigation/drawer';
import { API_URL } from '../common/constants/AppConstants';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../redux/store';
import { fetchProfileSettings } from '../redux/slices/profileSettingsSlice';

import { useScreenSize } from '../common/hooks/UseScreenDimention';
import Dashboard from './dashboard/Dashboard';
import Inventory from './Inventory/Inventory';
import Settings from './settings/Settings';
import Customers from './customer/customers/Customers';
import Reservations from './reservations/Reservations';
import { getAPICommitId, logout, testTokenValid } from '../api/Auth';
import Orders from './orders/Orders';
import Scheduler from './scheduler/Scheduler';
import { useHambugerMenuHistory } from '../common/hooks/UseHambugerMenuHistory';
import Marketing from './marketing/Marketing';
import DemandsList from './reservations/DemansList';
import LocationManager from './marketing/locationmanager/Locations';
import Avaiable from './marketing/avaiable/Avaiable';
import Forecasting from './marketing/forecasting/Forecasting';
import OrderPotential from './marketing/orderpotential/OrderPotential';
import PotentialList from './reservations/PotentialList';
import Plantations from './marketing/plantaions/Plantaions';
import PreMessages from './marketing/premessages/PreMessages';
import Streets from './marketing/streets/Streets';
import Properties from './marketing/properties/Properties';
import PMC from './settings/pmc/PMC';
import AbanndonedCarts from './abandonedcart/AbandonedCarts';
import Timeclock from './Timeclock/Timeclock';
import DailyLog from './Timeclock/dailylog/DailyLog';
import LogDetail from './Timeclock/dailylog/LogDetail';
import { ProceedReservation } from './reservations/ProceedReservation';
import Reports from './reports/Reports';
import BikeStandSalesReport from './reports/bikestandsalesreport/BikeStandSalesReport';
import TipsPaidReport from './reports/tipspaidreport/TipsPaidReport';
import { BOHChatbot } from '../common/components/bohchatbot/BOHChatbot';
import BasicQuizzes from './AI/basicquiz/BasicQuizzes';
import AIManager from './AI/AIManger';
import BillingSummery from './reports/billingsummeryreport/BillingSummery';
import PmcReport from './reports/pmcreport/PmcReport';
import CompareForecast from './marketing/forecasting/Compare';
import Automation from './automation/Automation';
import AddressAutomation from './automation/Address';
import TrackingTags from './trackingtags/TrackingTags';
import ProductHistory from './Inventory/product/products/ProductHistory';
import QuickScanScreen from './Inventory/QuickScanScreen';

const MainDrawer = ({ navigation }) => {

  const initialRouteName = 'Settings';

  const { isLargeScreen } = useScreenSize();
  const { addMenuHistory } = useHambugerMenuHistory();

  const Drawer = createDrawerNavigator();
  const [apiCommitId, setAPICommitId] = useState("");

  const [reservationId, setReservationId] = useState(null);
  // useEffect(()=>{
  //   addMenuHistory(initialRouteName);
  // }, []);

  useEffect(() => {
    const handleDeepLinking = async () => {
      try {
        const url = await Linking.getInitialURL();
        if (url) {
          const original = url.replace(/.*?:\/\//g, '');
          const parsedUrl = new URL(url);
          const params = Object.fromEntries(parsedUrl.searchParams.entries());
          const route = parsedUrl.pathname.replace(/^\/+|\/+$/g, '');
          if (route.toLowerCase().includes('dashboard')) {
            navigation.navigate('Dashboard');
          } else if (route.toLowerCase().includes('reservationdetail')) {
            navigation.navigate('ReservationDetail', params);
          } else if (route.toLowerCase().includes('reservation')) {
            navigation.navigate('Reservation');
          } else if (route.toLowerCase().includes('demandslist')) {
            navigation.navigate('DemandsList');
          } else if (route.toLowerCase().includes('walkup')) {
            navigation.navigate('Walkup Order');
          } else if (route.toLowerCase().includes('abandon')) {
            navigation.navigate('Abandoned Carts');
          } else if (route.toLowerCase().includes('inventory/quickscan')) {
            navigation.navigate('InventoryQuickScan');
          } else if (route.toLowerCase().includes('inventory')) {
            navigation.navigate('Inventory');
          } else if (route.toLowerCase().includes('customer')) {
            navigation.navigate('Customer');
          } else if (route.toLowerCase().includes('marketing')) {
            navigation.navigate('Marketing');
          } else if (route.toLowerCase().includes('plantations')) {
            navigation.navigate('Plantations');
          } else if (route.toLowerCase().includes('premessages')) {
            navigation.navigate('PreMessages');
          } else if (route.toLowerCase().includes('streets')) {
            navigation.navigate('Streets');
          } else if (route.toLowerCase().includes('properties')) {
            navigation.navigate('Properties');
          } else if (route.toLowerCase().includes('locations')) {
            navigation.navigate('Locations');
          } else if (route.toLowerCase().includes('forecasting')) {
            navigation.navigate('Forecasting');
          } else if (route.toLowerCase().includes('demands')) {
            navigation.navigate('Demands Summary');
          } else if (route.toLowerCase().includes('scheduler')) {
            navigation.navigate('Scheduler');
          } else if (route.toLowerCase().includes('settings')) {
            navigation.navigate('Settings');
          } else if (route.toLowerCase().includes('potential%20list') || route.toLowerCase().includes('potentiallist')) {
            navigation.navigate('Potential List');
          } else if (route.toLowerCase().includes('producthistory') || route.toLowerCase().includes('product%20history')) {
            navigation.navigate('ProductHistory', params);
          } else if (route.toLowerCase().includes('potential')) {
            navigation.navigate('Order Potential');
          } else if (route.toLowerCase().includes('dailylog')) {
            navigation.navigate('DailyLog');
          } else if (route.toLowerCase().includes('logdetail')) {
            navigation.navigate('LogDetail');
          } else if (route.toLowerCase().includes('bikestandsalesreport')) {
            navigation.navigate('BikeStandSalesReport');
          } else if (route.toLowerCase().includes('tipspaidreport')) {
            navigation.navigate('TipsPaidReport');
          } else if (route.toLowerCase().includes('billingsummery')) {
            navigation.navigate('BillingSummery');
          } else if (route.toLowerCase().includes('aimanager')) {
            navigation.navigate('AIManager');
          } else if (route.toLowerCase().includes('basicquiz')) {
            navigation.navigate('BasicQuiz');
          } else if (route.toLowerCase().includes('compareforecast')) {
            navigation.navigate('CompareForecast');
          } else if (route.toLowerCase().includes('addressautomation')) {
            navigation.navigate('AddressAutomation');
          } else if (route.toLowerCase().includes('trackingtags')) {
            navigation.navigate('TrackingTags', params);
          }
        }
      } catch (error) {
        console.error('Error fetching initial URL: ', error);
      }
    };
    handleDeepLinking();
    getAPICommitId((jsonRes)=>{
      setAPICommitId(jsonRes)
    })
  }, []);

  const screensConfig = [
    {
      name: "Dashboard",
      component: ({ navigation }) => { return <Dashboard navigation={navigation} /> },
      iconName: "dashboard.png",
      label: "Dashboard",
    }, {
      name: "Reservation",
      component: ({ navigation, route }) => {
        return <Reservations navigation={navigation} /> 
      },
      iconName: "reservations.png",
    }, {
      name: "ReservationDetail",
      component: ({ navigation, route }) => { 
        console.log(route.params);
        if(reservationId){
          return <Reservations navigation={navigation} />
        }
        else if(route?.params?.reservationId) return <ProceedReservation goBack={()=>{navigation.navigate(route?.params?.back??'Reservation')}} reservationId={route.params.reservationId}/>
      },
      iconName: "reservations.png",
      hidden: true,
    }, {
      name: "Walkup Order",
      component: ({ navigation }) => { return <Orders navigation={navigation} /> },
      iconName: "walk-up-order.png",
    }, {
      name: "Abandoned Carts",
      component: ({ navigation }) => { return <AbanndonedCarts navigation={navigation} /> },
      iconName: "walk-up-order.png",
    }, {
      name: "Inventory",
      component: ({ navigation }) => { return <Inventory navigation={navigation} /> },
      iconName: "inventory.png",
    }, {
      name: "Customers",
      component: ({ navigation }) => { return <Customers navigation={navigation} /> },
      iconName: "customers.png",
    }, {
      name: "Scheduler",
      component: ({ navigation }) => { return <Scheduler navigation={navigation} /> },
      hidden: true,
    }, {
      name: "Marketing",
      component: ({ navigation }) => { return <Marketing navigation={navigation} /> },
      iconName: "marketing.png",
    }, {
      name: "Locations",
      component: ({ navigation }) => { return <LocationManager navigation={navigation} /> },
      hidden: true,
    }, {
      name: "Plantations",
      component: ({ navigation }) => { return <Plantations navigation={navigation} /> },
      hidden: true,
    }, {
      name: "PreMessages",
      component: ({ navigation }) => { return <PreMessages navigation={navigation} /> },
      hidden: true,
    }, {
      name: "Streets",
      component: ({ navigation }) => { return <Streets navigation={navigation} /> },
      hidden: true,
    }, {
      name: "Properties",
      component: ({ navigation }) => { return <Properties navigation={navigation} /> },
      hidden: true,
    }, {
      name: "Forecasting",
      component: ({ navigation }) => { return <Forecasting navigation={navigation} /> },
      hidden: true,
    }, {
      name: "Demands Summary",
      component: ({ navigation }) => { return <Avaiable navigation={navigation} /> },
      hidden: true,
    }, {
      name: "Settings",
      component: ({ navigation, route }) => { return <Settings navigation={navigation} route={route} /> },
      iconName: "settings.png",
    }, {
      name: "DemandsList",
      component: ({ navigation }) => { return <DemandsList navigation={navigation} /> },
      hidden: true,
    }, {
      name: "Order Potential",
      component: ({ navigation }) => { return <OrderPotential navigation={navigation} /> },
      hidden: true,
    }, {
      name: "Potential List",
      component: ({ navigation }) => { return <PotentialList navigation={navigation} /> },
      hidden: true,
    }, {
      name: "ProductHistory",
      component: ({ navigation, route }) => { return <ProductHistory navigation={navigation} route={route} /> },
      hidden: true,
    }, {
      name: "Time Clock",
      component: ({ navigation }) => { return <Timeclock navigation={navigation} /> },
      iconName: "walk-up-order.png",
    }, {
      name: "DailyLog",
      component: ({ navigation }) => { return <DailyLog navigation={navigation} /> },
      hidden: true,
    }, {
      name: "LogDetail",
      component: ({ navigation }) => { return <LogDetail navigation={navigation} /> },
      hidden: true,
    }, {
      name: "Reports",
      component: ({ navigation }) => { return <Reports navigation={navigation} /> },
      iconName: "walk-up-order.png",
    }, {
      name: "BikeStandSalesReport",
      component: ({ navigation }) => { return <BikeStandSalesReport navigation={navigation} /> },
      iconName: "walk-up-order.png",
      hidden: true,
    }, {
      name: "TipsPaidReport",
      component: ({ navigation }) => { return <TipsPaidReport navigation={navigation} /> },
      iconName: "walk-up-order.png",
      hidden: true,
    }, {
      name: "BillingSummery",
      component: ({ navigation }) => { return <BillingSummery navigation={navigation} /> },
      iconName: "walk-up-order.png",
      hidden: true,
    }, {
      name: "PmcReport",
      component: ({ navigation }) => { return <PmcReport navigation={navigation} /> },
      iconName: "walk-up-order.png",
      hidden: true,
    }, {
      name: "AIManager",
      component: ({ navigation }) => { return <AIManager navigation={navigation} /> },
      iconName: "marketing.png",
    }, {
      name: "BasicQuiz",
      component: ({ navigation }) => { return <BasicQuizzes navigation={navigation} /> },
      hidden: true,
    }, {
      name: "CompareForecast",
      component: ({ navigation }) => { return <CompareForecast navigation={navigation} /> },
      hidden: true,
    }, {
      name: "Automation",
      component: ({ navigation }) => { return <Automation navigation={navigation} /> },
      iconName: "marketing.png",
    }, {
      name: "AddressAutomation",
      component: ({ navigation }) => { return <AddressAutomation navigation={navigation} /> },
      iconName: "marketing.png",
      hidden: true,
    }, {
      name: "TrackingTags",
      component: ({ navigation, route }) => { return <TrackingTags navigation={navigation} route={route} /> },
      iconName: "marketing.png",
      hidden: true,
    }, {
      name: "InventoryQuickScan",
      component: ({ navigation }) => { return <QuickScanScreen navigation={navigation} /> },
      hidden: true,
    },
  ];

  const drawerScreens = screensConfig.map((screen) => (
    <Drawer.Screen
      key={screen.name}
      name={screen.name}
      component={screen.component}
      options={{
        drawerLabel: screen?.label ?? screen.name,
        unmountOnBlur: true,
        headerShown: false,
        drawerIcon: ({ focused, size }) => (
          screen.iconName ? (
            <Image
              style={{ width: 25, height: 25, resizeMode: 'contain' }}
              source={require(`../assets/nav-icons/${screen.iconName}`)}
            />
          ) : (
            <></>
          )
        ),
        drawerItemStyle: {
          display: screen.hidden ? 'none' : 'flex',
        },
      }}
    />
  ));

  const DrawerContent = (props) => {
    const { navigation } = props;
    const dispatch = useDispatch<AppDispatch>();
    const { settings, loading } = useSelector((state: RootState) => state.profileSettings);
    const [logoUrl, setLogoUrl] = useState(null);
    const [isLogoError, setIsLogoError] = useState(false);
    
    // Create animated values using useRef for better performance
    const fadeAnim = useRef(new Animated.Value(0)).current;
    const placeholderFadeAnim = useRef(new Animated.Value(1)).current;
    
    // Fetch profile settings when component mounts
    useEffect(() => {
      dispatch(fetchProfileSettings(undefined));
    }, [dispatch]);
    
    // Update logo when settings change
    useEffect(() => {
      if (settings && settings.length > 0) {
        // Find logo in settings
        const logoSetting = settings.find(
          setting => setting.item_type === 'image' && setting.item_key === 'logo'
        );
        
        if (logoSetting && logoSetting.item_value) {
          // Reset states when URL changes
          setIsLogoError(false);
          fadeAnim.setValue(0);
          placeholderFadeAnim.setValue(1);
          setLogoUrl(logoSetting.item_value);
        }
      }
    }, [settings, fadeAnim, placeholderFadeAnim]);
    
    // Handle fade animation when logo loads
    const handleImageLoad = useCallback(() => {
      Animated.parallel([
        Animated.timing(fadeAnim, {
          toValue: 1,
          duration: 300,
          useNativeDriver: true,
        }),
        Animated.timing(placeholderFadeAnim, {
          toValue: 0,
          duration: 200,
          useNativeDriver: true,
        })
      ]).start();
    }, [fadeAnim, placeholderFadeAnim]);

    const handleImageError = useCallback(() => {
      setIsLogoError(true);
      // Ensure placeholder stays visible on error
      placeholderFadeAnim.setValue(1);
    }, [placeholderFadeAnim]);
    
    // Custom component for logo with animation
    const AnimatedLogo = () => {
      // Determine what to display based on current state
      const showPlaceholder = (isLogoError || !logoUrl) && !loading;
      const showCustomLogo = logoUrl && !isLogoError && !loading;
      const showLoading = loading;
      
      return (
        <View style={{ width: 70, height: 70, justifyContent: 'center', alignItems: 'center' }}>
          {/* Container for placeholder and loading indicator */}
          <View style={{ position: 'absolute' }}>
            {/* Placeholder logo */}
            {showPlaceholder && (
              <Animated.Image 
                source={require('../assets/icon.png')} 
                style={{ 
                  width: 70, 
                  height: 70,
                  opacity: placeholderFadeAnim
                }} 
              />
            )}
            
            {/* Loading indicator */}
            {showLoading && (
              <ActivityIndicator 
                size="small" 
                color="#0000ff" 
                style={{ 
                  position: 'absolute', 
                  top: '50%', 
                  left: '50%', 
                  transform: [{ translateX: -10 }, { translateY: -10 }] 
                }} 
              />
            )}
          </View>
          
          {/* Custom logo */}
          {showCustomLogo && (
            <Animated.Image 
              source={{ uri: API_URL + logoUrl }} 
              style={{ 
                width: 70, 
                height: 70, 
                resizeMode: 'contain',
                opacity: fadeAnim,
                position: 'absolute',
              }} 
              onLoad={handleImageLoad}
              onError={handleImageError}
            />
          )}
        </View>
      );
    };
    
    return (
      <View style={{ height: '100%', paddingBottom: 50 }}>
        <ScrollView>
          <DrawerItem
            label="#"
            onPress={() => navigation.navigate('Home')}
            icon={() => (
              <View style={{ width: '100%', alignItems: 'center' }}>
                <AnimatedLogo />
              </View>
            )}
            style={{ marginTop: 20 }}
            labelStyle={{ color: 'black', fontWeight: 'bold' }}
          />
          <DrawerItemList {...props} />
          <DrawerItem
            label="Log out"
            onPress={async () => {
              await logout(() => { });
              await AsyncStorage.setItem('access-token', '');
              await AsyncStorage.setItem('user-id', '');
              await AsyncStorage.setItem('user-name', '');
              await AsyncStorage.setItem('user-email', '');
              navigation.navigate('Auth');
            }}
          />
        </ScrollView>
        <View style={{ position: "absolute", bottom: 0, paddingBottom: 10, width: '100%' }}>
          <Text style={{ textAlign: 'center' }}>{`Version 1.0 - Commit ID main 78455922`}</Text>
          <Text style={{ textAlign: 'center' }}>{`Api version 1.0 - Commit ID ${apiCommitId}`}</Text>
        </View>
        {Platform.OS == 'web' && (
          <View style={{position:'fixed', bottom:0, right:0}}>
            <BOHChatbot/>
          </View>
        )}
      </View>
    );
  };

  return (
    <>
      <Drawer.Navigator
        initialRouteName={initialRouteName}
        drawerContent={(props) => <DrawerContent {...props} />}
        screenOptions={{
          drawerType: Platform.OS == 'web' && isLargeScreen ? 'permanent' : 'front',
          drawerStyle: { backgroundColor: '#f1f3fc', },
        }}
      >
        {drawerScreens}
      </Drawer.Navigator>
    </>
  );
};

const Home = ({ navigation }) => {
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const checkTokenValidity = async () => {
      await testTokenValid((jsonRes, status) => {
        if (status != 200) navigation.navigate('Auth');
      });
    };

    checkTokenValidity();
  }, []);

  useEffect(() => {

    const unsubscribe = navigation.addListener('state', () => {
      setRefreshKey((prevKey) => prevKey + 1);
    });

    return unsubscribe();
  }, [navigation]);

  return <MainDrawer key={refreshKey} navigation={navigation} />;
};

export default Home;
